import httpService from '~/utils/http';

// 获取目录信息 参数:path_map
export const getCategoryInfoApi = async (param) => await httpService({
  url: 'api/site/category/infoByMap',
  data: param
});

// 获取目录列表 参数:path_map|page_index|page_size|level
export const getCategoryListApi = async (param) => await httpService({
  url: '/api/site/category/listByMap',
  data: param
});

// 获取文章信息 参数:parent_id
export const getArticleListApi = async (param) => await httpService({
  url: '/api/site/article/list',
  data: param
});

// 获取文章内容 参数:parent_id&article_id
export const getArticleContentApi = async (param) => await httpService({
  url: '/api/site/article/content',
  data: param
});
